import { useEffect } from "react";

import { fontStack } from "../../lib/typography.js";
import { useSettingsStore } from "../../stores/settings.store.js";

export function TypographyStyleInjector() {
  const textScale = useSettingsStore((s) => s.textScale);
  const textFont = useSettingsStore((s) => s.textFont);

  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty("--app-text-scale", String(textScale));
    root.style.setProperty("--app-font-family", fontStack(textFont));
  }, [textScale, textFont]);

  return null;
}
